<template>
  <div class="login-open-page">
    <div class="join" v-if="!isFetch">
      <div class="loading-container">
        <p>
          <img src="@img/group2.png" />
        </p>
        <p>正在加载...</p>
      </div>
    </div>
    <div v-else>
      <img class="logo" alt :src="customerInfo.brandLogo" v-if="customerInfo.brandLogo" />
      <div class="name" v-if="customerInfo.name">{{ customerInfo.name }}</div>
      <div class="forms">
        <!-- 手机号码 -->
        <div class="form-group">
          <img class="icon-phone" src="@img/icon-phone@2x.png" alt="" />
          <input
            @keydown="cleanError('errorMobile')"
            id="bind-mobile"
            type="tel"
            maxlength="13"
            class="input-control"
            v-model="mobile"
            placeholder="请输入手机号码"
          />
        </div>
        <div v-show="errorMobile" class="errorTip">{{ errorMobile }}</div>

        <!-- 短信验证码 -->
        <div class="form-group">
          <img class="icon-sms-code" src="@img/icon-sms-code@2x.png" alt="" />
          <input @keydown="cleanError('errorSmsCode')" class="input-control" maxlength="6" v-model="smsCode" placeholder="请输入短信验证码" />
          <sms-code-vc
            class="getSmsCode"
            :times="60"
            :status="smsStatus"
            :pos="smsPos"
            :disable="isSmsDisable"
            :resetCountdown="resetCountdown"
            v-on:smsCodeClick="getSmsCaptchaCode"
            @click.native="handleSmsNativeClick"
          />
        </div>
        <div v-show="errorSmsCode" class="errorTip">{{ errorSmsCode }}</div>

        <!-- 图形验证码 -->
        <div class="form-group" v-if="isShowImgCaptcha">
          <input @keydown="cleanError('errorImgCode')" class="input-control" v-model="imgCode" placeholder="图形验证码" />
          <img :src="imgUrl" alt class="ic-pic" @click="getImgCaptchaCode" />
        </div>
        <div v-show="errorImgCode" class="errorTip">{{ errorImgCode }}</div>
        <div v-show="errorTip" class="errorTip">{{ errorTip }}</div>
      </div>

      <!-- 登录 -->
      <div class="loginBtn" :class="{ 'login-btn-disable': !isEnable }" @click="doLogin">
        {{ isWechatBind ? '确认绑定' : '登录' }}
      </div>

      <!-- 勾选用户协议、隐私政策 -->
      <div class="user-agreement">
        <img class="icon-check" :src="checkIcon" alt="" @click="handleCheckbox" />
        <span>
          我已阅读并同意
          <span class="highlight" @click="handlePolicies">《隐私政策》</span>
          和
          <span class="highlight" @click="handleAgreement">《服务协议》</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty } from '@yxcx/util'
import { MessageBox, Toast, Indicator } from 'mint-ui'
import Service from '@svc/login'
import userService from '@svc/user'
import wechatService from '@svc/wechat'
import smsCodeVc from '@comp/sms_code.vue'
import { setFavicon, MobileReg, formatNumber, rmSpace } from '@util/function'
import clientinfo from '@util/x-client-info'
import setDocumentTitle from '@util/document-title'
import {
  forbidCookie,
  forbidLogin,
  LoginType,
  getLoginType,
  handleOpLoginResult,
  handleUnifiedOpLoginResult,
  useLoginToken,
  useOpenId,
} from './use/useLoginOpen'

const EMPTY_IMG = '请输入图形验证码'
const WRONG_IMG = '图形验证码错误'
const EMPTY_SMS = '请输入验证码'

const EMPTY_MOBILE = '请输入手机号码'
const WRONG_MOBILE = '请输入正确的手机号码'

export default {
  components: {
    'sms-code-vc': smsCodeVc,
  },
  data() {
    return {
      errorSmsCode: '',
      errorMobile: '',
      resetCountdown: false,
      smsStatus: 1,
      isSmsDisable: true,

      smsCode: '',
      mobile: '',
      errorTip: '',
      isShowImgCaptcha: false,
      imgUrl: '',
      imgKey: '',
      imgCode: '',
      errorImgCode: '',
      // 是否勾选底部服务条款
      isChecked: false,

      // 登录类型
      loginType: LoginType.UNIFIED,
      // 大客户信息
      customerInfo: {},
      // 商城配置
      mallConfig: {},
      // 初始化完成
      isFetch: false,
      // 正在请求登录、获取验证码
      loading: false,
      // 微信授权登录跳转过来会携带 loginToken
      loginToken: '',
    }
  },
  computed: {
    isUnifiedLogin() {
      const LoginTypes = [LoginType.OP_UNIFIED, LoginType.OP_UNIFY_WECHAT]
      return LoginTypes.includes(this.loginType)
    },
    // 定制域名微信绑定
    isWechatBind() {
      const LoginTypes = [LoginType.OP_WECHAT]
      return LoginTypes.includes(this.loginType)
    },
    isEnable() {
      return !isEmpty(this.mobile) && !isEmpty(this.smsCode)
    },
    checkIcon() {
      return this.isChecked ? require('@img/icon-checked@2x.png') : require('@img/icon-unchecked@2x.png')
    },
    smsPos() {
      const invalidText = this.getInvalidMobileText(this.mobile)
      return {
        color: isEmpty(invalidText) ? '#ff3500' : '#c8c9cc',
      }
    },
  },
  watch: {
    mobile(v) {
      const mobile = rmSpace(v)
      if (mobile.length === 11) return (this.isSmsDisable = false)
      this.resetCountdown = +new Date()
      this.isSmsDisable = true
    },
  },
  mounted() {
    if (forbidCookie()) {
      return
    }
    this.setupConfig()
  },
  methods: {
    async setupConfig() {
      // 登录类型
      this.loginType = getLoginType(this.$route.query)
      setDocumentTitle(this.isWechatBind ? '微信绑定' : '登录')

      try {
        this.isFetch = false
        const { code } = this.$route.query
        if (code) {
          const res = await Service.getAllConfigInfo({ code })
          this.customerInfo = res.customerInfo
          this.mallConfig = res.mallConfig
          setFavicon(res.customerInfo.mallIcon)
          clientinfo.setInfo({
            o: res.customerInfo.operatorId + '',
          })
        } else {
          this.customerInfo = {
            name: '',
            brandLogo: require('@img/main-logo.png'),
          }
        }
      } catch (error) {
        console.error(error)
        this.$router.push('/login/tips')
      } finally {
        this.isFetch = true
      }
    },
    async doLogin() {
      if (this.loading) {
        return
      }
      if (this.checkFields()) {
        return
      }
      this.loading = true
      Indicator.open()
      try {
        await this.requestLogin()
        Indicator.close()
      } catch (e) {
        console.error(e)
        Indicator.close()
        this.loginError(e)
      } finally {
        this.loading = false
      }
    },
    composeOptions() {
      const { imgKey, imgCode, smsCode, mobile, customerInfo } = this
      const opts = {
        imgKey,
        imgCode,
        smsCode,
        mobile: rmSpace(mobile),
      }
      if (!this.isUnifiedLogin) {
        opts.operatorId = customerInfo.operatorId
      }
      return opts
    },
    async requestLogin() {
      // 企业被禁止登录
      if (!this.isUnifiedLogin && forbidLogin(this.customerInfo)) {
        return Promise.reject()
      }

      await this.dispatchLoginProcess()
    },
    async dispatchLoginProcess() {
      const loginStrategies = {
        [LoginType.OP]: () => this.customOpLogin(),
        [LoginType.OP_WECHAT]: () => this.customOpLogin(),
        [LoginType.OP_UNIFIED]: () => this.unifiedOpLogin(),
        [LoginType.OP_UNIFY_WECHAT]: () => this.unifiedOpLogin(),
      }
      await loginStrategies[this.loginType]()
    },
    async customOpLogin() {
      const options = this.composeOptions()
      const { loginToken, hasLoginToken } = useLoginToken(this.$route.query)

      // 微信绑定手机号时，存在 loginToken
      if (hasLoginToken) {
        // 根据手机号码查询已绑定的 openId 信息
        await this.handleWechatBind()
        options.loginToken = loginToken
      }
      const res = await Service.stMallLogin(options)
      handleOpLoginResult(res, this.composeResultOptions())
    },
    async unifiedOpLogin() {
      const options = this.composeOptions()
      const { openId, hasOpenId } = useOpenId(this.$route.query)
      // 微信统一登录时，存在 openId
      if (hasOpenId) {
        options.openId = openId
      }
      const res = await Service.unifiedOpLogin(options)
      handleUnifiedOpLoginResult(res, this.composeResultOptions())
    },
    async handleWechatBind() {
      const mobile = rmSpace(this.mobile)
      const { code } = this.$route.query
      const options = {
        mobile,
        mallCode: code,
        smsCode: this.smsCode,
      }
      const { isBind } = await wechatService.getWechatBindInfo(options)
      // 已绑定其他微信，需要提示解绑
      if (isBind) {
        const boxRes = await MessageBox({
          title: '',
          message: '当前账户已被其他微信账号绑定，若确认绑定当前微信，则会自动解除与原微信账号的绑定',
          confirmButtonText: '继续绑定',
          cancelButtonText: '取消',
          showCancelButton: true,
        })
        if (boxRes === 'confirm') {
          await wechatService.mobileUnbindWechat(options)
        } else {
          // 取消抛出一个空异常
          return Promise.reject()
        }
      }
    },
    composeResultOptions() {
      return {
        query: this.$route.query,
        router: this.$router,
        store: this.$store,
        customerInfo: this.customerInfo,
      }
    },
    checkMobile() {
      this.errorMobile = this.getInvalidMobileText(this.mobile)
    },
    getInvalidMobileText(m) {
      m = rmSpace(m)
      return m === '' ? EMPTY_MOBILE : MobileReg.test(m) ? '' : WRONG_MOBILE
    },
    handleSmsNativeClick() {
      this.checkMobile()
    },
    // 获取短信验证码
    async getSmsCaptchaCode() {
      const mobile = rmSpace(this.mobile)
      try {
        const opts = { type: '1', mobile }
        if (this.isUnifiedLogin) {
          // 统一登录时传递，锦福利：0，星享福、星享福企业版：1
          opts.customerType = 1
        }
        const operatorId = this.customerInfo?.operatorId
        if (operatorId) {
          opts.operatorId = +operatorId
        }
        await Service.smsSend(opts)
        this.errorSmsCode = ''
      } catch (e) {
        console.error(e)
        this.errorSmsCode = e.msg
      }
    },
    cleanError(type) {
      this.cleanErr(type)
      this.mobile = formatNumber(rmSpace(this.mobile))
    },
    checkFields() {
      this.checkMobile()
      if (this.errorMobile) {
        return true
      }
      if (!this.smsCode) {
        return (this.errorSmsCode = EMPTY_SMS)
      }
      if (this.isShowImgCaptcha && !this.imgCode) {
        return (this.errorImgCode = EMPTY_IMG)
      }
      if (!this.isChecked) {
        Toast('请先阅读并同意下方服务条款')
        return true
      }
      return false
    },
    cleanErr(type) {
      this[type] = ''
      this.errorTip = ''
    },
    loginError(e) {
      if (!e) return

      if ([6006, 6007].includes(e.status)) {
        this.isShowImgCaptcha = true
        this.errorTip = ''
        this.errorImgCode = e.status === 6006 ? WRONG_IMG : EMPTY_IMG
        this.getImgCaptchaCode()
        return
      }
      if (e.status === 70019) {
        MessageBox.alert(e.msg)
        return
      }
      if (e.status === 70005) {
        Toast({
          message: e.msg,
          position: 'bottom',
          duration: 3000,
        })
        return
      }
      this.errorTip = e.msg || '登录失败'
    },
    // 获取图文验证码
    async getImgCaptchaCode() {
      try {
        this.loading = true
        let res = await userService.getImgCaptcha()
        this.imgUrl = res.imgUrl
        this.imgKey = res.imgKey
      } catch (e) {
        this.errorImgCode = e.msg
      } finally {
        this.loading = false
      }
    },
    handleCheckbox() {
      this.isChecked = !this.isChecked
    },
    handlePolicies() {
      window.location.href = '/op/user/privacy-policy'
    },
    handleAgreement() {
      window.location.href = '/op/user/service-agreement'
    },
  },
}
</script>
<style lang="less" scoped>
.loading-container {
  margin-top: 236px;
  text-align: center;
  color: #bdc0c5;
  font-size: 14px;
  height: calc(~'100vh - 236px');
  overflow: hidden;
  box-sizing: border-box;
  img {
    width: 35px;
    animation: myrotate 1.5s infinite;
    -webkit-animation: myrotate 1.5s infinite;
  }
}

.login-open-page {
  padding-top: 64px;
  background-image: url('~@img/login-top-bg@2x.png');
  background-size: 100% calc((302 / 750) * 100vw);
  background-repeat: no-repeat;
  background-position: 0 0;

  .logo {
    width: 64px;
    height: 64px;
    border-radius: 8px;
    margin: 0 auto;
    display: block;
  }

  .sms_modal {
    width: 90px;
    height: 30px;
    position: absolute;
    right: 0px;
    top: 14px;
    z-index: 1;
  }

  :deep(.getSmsCode) {
    flex-shrink: 0;
  }

  .name {
    font-size: 14px;
    font-weight: 500;
    color: #000;
    text-align: center;
    margin-top: 15px;
  }

  .forms {
    margin-top: 50px;

    .errorTip {
      text-align: left;
      color: #ff3500;
      line-height: 11px;
      font-size: 11px;
      line-height: 18px;
      margin: 8px 24px 0;
    }

    .form-group {
      position: relative;
      display: flex;
      align-items: center;
      height: 44px;
      margin: 12px 24px 0;

      .icon-phone,
      .icon-sms-code {
        width: 21px;
        height: 21px;
        margin-right: 5px;
      }

      .input-control {
        height: 15px;
        line-height: 15px;
        padding: 15px 0;
        width: 100%;
        font-size: 15px;
        color: #191a1b !important;
        border: 0;
        outline-width: 0;
        outline: none;
      }

      input::-webkit-input-placeholder,
      input::-moz-placeholder,
      input:-moz-placeholder,
      input:-ms-input-placeholder {
        color: #969799;
        font-size: 14px;
      }

      &:after {
        content: ' ';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        color: #ededed;
        transform-origin: 0 0;
        border-bottom: 1px solid #ededed;
        transform: scaleY(0.5);
      }

      .ic-pic {
        height: 26px;
        position: absolute;
        right: 0;
        top: 13px;
      }
    }
  }

  .loginBtn {
    height: 44px;
    line-height: 44px;
    margin: 0 24px;
    margin-top: 44px;
    background: #ff3500;
    border-radius: 22px;
    text-align: center;
    font-size: 16px;
    color: #fff;
  }

  .login-btn-disable {
    opacity: 0.3;
  }

  .user-agreement {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    color: #797d82;
    margin-top: 28px;

    .icon-check {
      width: 11px;
      height: 11px;
      margin-right: 4px;
    }

    .highlight {
      color: #ff3500;
    }
  }
}
</style>
